var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleAxiosError } from '@app/api/utils/handleAxiosError';
import { HTTP_METHODS } from '@app/configs/api';
import { setGlobalError } from '@app/store/errorSlice';
import { store } from '@app/store/store';
const GLOBAL_ERROR_STATUS_CODES = [500];
const createBaseQuery = (client) => {
    return (_a) => __awaiter(void 0, [_a], void 0, function* ({ url, method = HTTP_METHODS.GET, body, params, responseType }) {
        try {
            const result = yield client({
                url,
                method,
                data: body,
                params,
                responseType,
            });
            return { data: result.data };
        }
        catch (axiosError) {
            const err = axiosError;
            const serializedError = handleAxiosError(err);
            if (err.response && GLOBAL_ERROR_STATUS_CODES.includes(err.response.status)) {
                store.dispatch(setGlobalError(serializedError));
            }
            return {
                error: serializedError,
            };
        }
    });
};
export default createBaseQuery;
